import {format, parseISO} from 'date-fns';
import {getFullName} from '../../../shared/helpers/getFullName';
import {IServiceRequest} from '../../../shared/types/serviceRequest.types';
import {IUserAccount} from '../../../shared/types/user-account.types';
import {DATE_FORMAT_FNS, DATETIME_FORMAT_FNS} from '../../../shared/constants/date-formats';

export interface IADPUVars {
  devicenumber: string;
  customer: string;
  userPhoneNumber: string;
  userFio: string;
  customerPhone: string;
  idLicAccount: string;
  email: string;
  city: string;
  street: string;
  house: string;
  apartment: string;
  taskLocation: string;
  devicename: string;
  contentDevicenumber: string;
  contentSummaOld: string;
  contentT1Old: string;
  contentT2Old: string;
  contentSumma: string;
  contentT1: string;
  contentT2: string;
  productdate: string;
  lastControlDate: string;
  nextControlDate: string;
  contentSealnumberOld: string;
  contentSealnumber: string;
  contentProductdate: string;
  contentLastControlDate: string;
  contentNextControlDate: string;
  contentSimNumber: string;
  reason: string;
  day: string;
  month: string;
  year: string;
  hours: string;
  minutes: string;
}

export interface IDelayDocVars {
  idDelay: string;
  devicenumber: string;
  customer: string;
  userPhoneNumber: string;
  userFio: string;
  customerPhone: string;
  idLicAccount: string;
  email: string;
  city: string;
  street: string;
  house: string;
  apartment: string;
  taskLocation: string;
  devicename: string;
  contentDevicename: string;
  contentDevicenumber: string;
  contentSummaOld: string;
  contentT1Old: string;
  contentT2Old: string;
  contentSumma: string;
  contentT1: string;
  contentT2: string;
  productdate: string;
  lastControlDate: string;
  nextControlDate: string;
  contentSealnumberOld: string;
  contentSealnumber: string;
  contentProductdate: string;
  contentLastControlDate: string;
  contentNextControlDate: string;
  contentSimNumber: string;
  reason: string;
  day: string;
  month: string;
  year: string;
  hours: string;
  minutes: string;
}

//todo: вынести генерацию PDF в WebWorker
export const normalizeServiceRequestForDelayDoc = (
  serviceRequest: IServiceRequest,
  user: IUserAccount,
  delayData: {delay: Record<string, any>; localOrder: number},
) => {
  const dateAndTime = new Intl.DateTimeFormat('ru-RU', {
    hour: 'numeric',
    minute: 'numeric',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'Europe/Moscow',
  })
    .format(new Date(delayData.delay.date))
    .split(',')
    .map((i) => i.trim());

  const dateParts = dateAndTime[0].split('.');
  const timeParts = dateAndTime[1].split(':');

  return {
    idDelay: serviceRequest?.sourceContent?.idLicAccount?.value
      ? `${serviceRequest?.sourceContent?.idLicAccount?.value}-${delayData.localOrder}`
      : '',
    userFio: getFullName(user as IUserAccount),
    userPhoneNumber: user?.phoneNumber || '',
    apartment: serviceRequest?.apartment || serviceRequest?.address?.apartment || '',
    city: serviceRequest?.city?.name || serviceRequest?.address?.city?.name || '',
    house: serviceRequest?.house || serviceRequest?.address?.house || '',
    street: serviceRequest?.street?.name || serviceRequest?.address?.street?.name || '',
    devicename: serviceRequest?.sourceContent?.devicename?.value || '',
    devicenumber: serviceRequest?.sourceContent?.devicenumber?.value || '',
    taskLocation: serviceRequest?.taskLocation?.name || '',
    reason: serviceRequest?.sourceContent?.reason?.value || '',
    productdate: serviceRequest?.sourceContent?.productdate?.value || '',
    nextControlDate: serviceRequest?.sourceContent?.nextControlDate?.value || '',
    lastControlDate: serviceRequest?.sourceContent?.lastControlDate?.value || '',
    idLicAccount: serviceRequest?.sourceContent?.idLicAccount?.value || '',
    customer: serviceRequest?.customer || '',
    customerPhone:
      serviceRequest?.customerPhone && serviceRequest?.customerPhone !== '-' ? serviceRequest?.customerPhone : '',
    email: serviceRequest?.email && serviceRequest?.email !== '-' ? serviceRequest?.email : '',
    day: dateParts[0],
    month: dateParts[1],
    year: dateParts[2].slice(2),
    hours: timeParts[0],
    minutes: timeParts[1],
  } as IDelayDocVars;
};

export const getTargetElement = (id: string) => document.getElementById(id);

export const normalizeServiceRequestForADPUDoc = (serviceRequest: IServiceRequest, user: IUserAccount): IADPUVars => {
  const dateAndTime = new Intl.DateTimeFormat('ru-RU', {
    hour: 'numeric',
    minute: 'numeric',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'Europe/Moscow',
  })
    .format(new Date())
    .split(',')
    .map((i) => i.trim());

  const dateParts = dateAndTime[0].split('.');
  const timeParts = dateAndTime[1].split(':');

  return {
    userFio: getFullName(user),
    userPhoneNumber: user?.phoneNumber || '',
    apartment: serviceRequest?.apartment || serviceRequest?.address?.apartment || '',
    city: serviceRequest?.city?.name || serviceRequest?.address?.city?.name || '',
    house: serviceRequest?.house || serviceRequest?.address?.house || '',
    street: serviceRequest?.street?.name || serviceRequest?.address?.street?.name || '',
    devicename: serviceRequest?.sourceContent?.devicename?.value || '',
    devicenumber: serviceRequest?.sourceContent?.devicenumber?.value || '',
    taskLocation: serviceRequest?.taskLocation?.name || '',
    reason: serviceRequest?.sourceContent?.reason?.value || '',
    productdate: serviceRequest?.sourceContent?.productdate?.value || '',
    nextControlDate: serviceRequest?.sourceContent?.nextControlDate?.value || '',
    lastControlDate: serviceRequest?.sourceContent?.lastControlDate?.value || '',
    idLicAccount: serviceRequest?.sourceContent?.idLicAccount?.value || '',
    customer: serviceRequest?.customer || '',
    customerPhone:
      serviceRequest?.customerPhone && serviceRequest?.customerPhone !== '-' ? serviceRequest?.customerPhone : '',
    email: serviceRequest?.email && serviceRequest?.email !== '-' ? serviceRequest?.email : '',
    day: dateParts[0],
    month: dateParts[1],
    year: dateParts[2].slice(2),
    hours: timeParts[0],
    minutes: timeParts[1],
    contentDevicenumber: serviceRequest?.workData?.devicenumber?.value || '',
    contentSummaOld: serviceRequest?.workData?.summaOld?.value || '',
    contentT1Old: serviceRequest?.workData?.t1Old?.value || '',
    contentT2Old: serviceRequest?.workData?.t2Old?.value || '',
    contentSumma: serviceRequest?.workData?.summa?.value || '',
    contentT1: serviceRequest?.workData?.t1?.value || '',
    contentT2: serviceRequest?.workData?.t2?.value || '',
    contentSealnumber: serviceRequest?.workData?.sealnumber?.value || '',
    contentSealnumberOld: serviceRequest?.workData?.sealnumberOld?.value || '',
    contentProductdate: serviceRequest?.workData?.productdate?.value || '',
    contentLastControlDate: serviceRequest?.workData?.lastControlDate?.value
      ? new Intl.DateTimeFormat('ru-RU', {timeZone: 'Europe/Moscow'}).format(
          new Date(serviceRequest?.workData?.lastControlDate?.value.split('-').reverse().join('-')),
        )
      : '',
    contentNextControlDate: serviceRequest?.workData?.nextControlDate?.value
      ? new Intl.DateTimeFormat('ru-RU', {timeZone: 'Europe/Moscow'}).format(
          new Date(
            serviceRequest?.workData?.nextControlDate?.value.includes('-')
              ? serviceRequest?.workData?.nextControlDate?.value.split('-').reverse().join('-')
              : serviceRequest?.workData?.nextControlDate?.value,
          ),
        )
      : '',
    contentSimNumber: serviceRequest?.workData?.simNumber?.value || '',
  };
};

export function formatIsoDate(isoString: string, pattern = DATE_FORMAT_FNS): string {
  if (!isoString) return '-';

  const date = parseISO(isoString);

  if (isNaN(date.getTime())) return '-';

  return format(date, pattern);
}
